import Button from "react-bootstrap/Button";
import Spinner from "react-bootstrap/Spinner";

function SpinnerBootstrap() {
  return (
    <div
      style={{
        textAlign: "center",
        padding: "10px",
      }}
    >
      <Button variant="primary" disabled>
        <Spinner
          as="span"
          animation="border"
          size="sm"
          role="status"
          aria-hidden="true"
        />
        <span className="visually-hidden"> Loading...</span>
      </Button>{" "}
    </div>
  );
}

export default SpinnerBootstrap;
